import { useNavigate } from 'react-router-dom';
import Button from '../../components/Button';
import Card from '../../components/Card';
import CheckRole from '../../components/CheckRole';
import DangerButton from '../../components/DangerButton';
import { Input, TextAreaField } from '../../components/FormComponents';
import { H2, PageHeading } from '../../components/Headings';
import Modal from '../../components/Modal';
import useForum from '../../hooks/useForum';
import useLocale from '../../hooks/useLocale';
import { formatDate } from '../../utils';

function ShowForum() {
  const { l } = useLocale();
  const navigate = useNavigate();
  const {
    forum,
    handleSave,
    handleReply,
    replyOpenModal,
    replyShowModal,
    replyCloseModal,
    replyRef,
    handleDeleteReply,
    handleDelete,
    editForumOpenModal,
    editForumShowModal,
    editForumCloseModal,
    handleForumChange,
    editReplyOpenModal,
    editReplyShowModal,
    editReplyCloseModal,
    editReplyRef,
    setEditReplyId,
    handleEditReply,
  } = useForum();

  return (
    <>
      <PageHeading title={forum.title} image={'/img/forum.svg'}>
        <Button type="warning" onClick={() => navigate('/forums')} className="flex gap-2">
          <img src="/img/back.svg" className="max-w-[20px]" alt="" />
          {l('return_to_forums')}
        </Button>
        <Button type="primary" onClick={replyOpenModal} className="flex gap-2">
          <img src="/img/answer.svg" className="max-w-[20px]" alt="" />
          {l('reply_to_forum')}
        </Button>
      </PageHeading>

      <Card>
        <div className="px-2 py-1 my-2 border rounded-md">
          <div className="flex justify-between mb-4">
            <p>
              <strong>{l('user')}: </strong>
              {forum.user.name}
            </p>
            <p>
              <strong>{l('creation_date')}: </strong>
              {formatDate(forum.createdAt)}
            </p>
            <p>
              <strong>{l('modification_date')}: </strong>
              {formatDate(forum.updatedAt)}
            </p>
          </div>
          <p className="mb-2 whitespace-pre-line">{forum.description}</p>
          <div className="flex gap-3 justify-end mb-2 ml-1">
            <CheckRole has="edit_forums">
              <Button onClick={editForumOpenModal}>
                <img className="w-[25px]" src="/img/view.svg" alt="" />
              </Button>
            </CheckRole>
            <CheckRole has="delete_forums">
              <DangerButton onClick={() => handleDelete(forum._id)} />
            </CheckRole>
          </div>
        </div>

        <H2 className="my-5 font-bold">{l('replies')}</H2>

        {forum.replies.map(reply => {
          return (
            <div key={reply._id} className="px-2 py-1 my-2 border rounded-md">
              <div className="flex justify-between mb-4">
                <p>
                  <strong>{l('user')}: </strong>
                  {reply.user.name}
                </p>
                <p>
                  <strong>{l('creation_date')}: </strong>
                  {formatDate(reply.createdAt)}
                </p>
                <p>
                  <strong>{l('modification_date')}: </strong>
                  {formatDate(reply.updatedAt)}
                </p>
              </div>
              <p className="font-bold mt-2">{l('reply')}:</p>
              <p className="mb-2 whitespace-pre-line">{reply.reply}</p>
              <div className="flex gap-3 justify-end mb-2 ml-1">
                <CheckRole has="edit_forum_replies">
                  <Button
                    onClick={() => {
                      editReplyOpenModal();

                      editReplyRef.current.value = reply.reply;
                      setEditReplyId(reply._id);
                    }}
                  >
                    <img className="w-[25px]" src="/img/view.svg" alt="" />
                  </Button>
                </CheckRole>
                <CheckRole has="delete_forum_replies">
                  <DangerButton onClick={() => handleDeleteReply(reply._id)} />
                </CheckRole>
              </div>
            </div>
          );
        })}
      </Card>

      <Modal show={replyShowModal} onClose={replyCloseModal}>
        <H2>{l('add_reply')}</H2>
        <form onSubmit={handleReply}>
          <TextAreaField label={l('reply')} reference={replyRef} />
          <Button full type="secondary">
            {l('add')}
          </Button>
        </form>
      </Modal>

      <Modal show={editReplyShowModal} onClose={editReplyCloseModal}>
        <H2>{l('edit_reply')}</H2>
        <form onSubmit={handleEditReply}>
          <TextAreaField label={l('reply')} reference={editReplyRef} />
          <Button full type="secondary">
            {l('edit')}
          </Button>
        </form>
      </Modal>

      <Modal show={editForumShowModal} onClose={editForumCloseModal}>
        <H2>{l('edit_forum')}</H2>
        <form onSubmit={handleSave}>
          <Input label={l('title')} name="title" value={forum.title} onChange={handleForumChange} />
          <TextAreaField
            label={l('description')}
            name="description"
            value={forum.description}
            onChange={handleForumChange}
          />
          <Button full type="secondary">
            {l('edit')}
          </Button>
        </form>
      </Modal>
    </>
  );
}

export default ShowForum;
